export default "__VITE_ASSET__37504e19__"